import type { StartFailure } from './parseStartError'
import { translationFailureText } from './translationFailureText'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Текст отказа языковых действий курса — удаления языка, смены базового,
 * отмены прогона. Ручки молчат в глобальном тосте (`SILENT_ENDPOINTS`): тот
 * показал бы «Conflict» или JSON объектного `detail`.
 *
 * `fallback` — у каждого действия свой: общий «Не удалось запустить прогон»
 * соврал бы про суть, эти ручки прогон не запускают.
 */
export const courseLanguageFailureText = (failure: StartFailure, fallback: string): string => {
  const code = 'code' in failure ? failure.code : undefined
  const known = code ? translationFailureText(code, failure.message) : null
  if (known) return known
  if (failure.kind === 'course_busy') return messagesNow(messages).courseRunInProgress
  return fallback
}
